const breakpoint96InPixel = 1024;

export const canLayoutSidebarBeDisplayed = () =>
  window.innerWidth >= breakpoint96InPixel;
